/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
import { ApiElementPositionFromJSON, ApiElementPositionToJSON, } from './ApiElementPosition';
export function ApiElementReorderPayloadFromJSON(json) {
    return ApiElementReorderPayloadFromJSONTyped(json, false);
}
export function ApiElementReorderPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'positions': !exists(json, 'positions') ? undefined : (mapValues(json['positions'], ApiElementPositionFromJSON)),
    };
}
export function ApiElementReorderPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'positions': value.positions === undefined ? undefined : (mapValues(value.positions, ApiElementPositionToJSON)),
    };
}
